import { MoloniOauthComponent } from './dashboard/moloni-oauth/moloni-oauth.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules, NoPreloading } from '@angular/router';
import { UserGuard } from './core/guards/user.guard';
import { MerchantGuard } from './core/guards/merchant.guard';
import { BukAdminGuard } from './core/guards/buk-admin.guard';
import { GlobalParamsGuard } from './core/guards/global-params.guard';
import { SetLanguageGuard } from './core/guards/set-language.guard';
import { environment } from '../environments/environment';
import { RoleAdminGuard } from './core/guards/role.admin.guard';
import { HasActiveSubscriptionGuard } from './core/guards/has-active-subscription.guard';
import { LandingComponent } from './landing/landing.component';
import { landingRoutes } from './landing/landing-routing.module';
import { supportRoutes } from './support/support-routing.module';
import { adminRoutes } from './admin/admin-routing.module';
import { dashboardRoutes } from './dashboard/dashboard-routing.module';
import { D } from '@angular/cdk/bidi-module.d-D-fEBKdS';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminComponent } from './admin/admin.component';
import { clientEditorRoutes } from './client-editor/client-editor-routing.module';
import { onboardRoutes } from './onboard/onboard-routing.module';
import { clientRoutes } from './client/client-routing.module';
import { GuestGuard } from './core/guards/guest.guard';
import { MerchantHasSetupGuardGuard } from './core/guards/merchant-has-setup-guard.guard';

const languageRoutes: Routes = environment.languages.map((language) => ({
  path: language.code,
  children: landingRoutes,
  pathMatch: 'full',
  data: { state: 'subdomainLanguage' },
  canActivate: [SetLanguageGuard, GlobalParamsGuard],
}));

export const routes: Routes = [
  { path: '', canActivate: [GlobalParamsGuard], data: { state: 'landing' }, children: landingRoutes },
  { path: 'support', children: supportRoutes, data: { state: 'client' } },
  {
    path: 'logout',
    pathMatch: 'full',
    children: landingRoutes,
  },
  { path: 'admin', component: AdminComponent, children: adminRoutes, canActivate: [BukAdminGuard ] },
  {
    path: 'cancel-subscription',
    loadComponent: () =>
      import('./cancelation/cancel-subscription-page/cancel-subscription-page.component').then((m) => m.CancelSubscriptionPageComponent),
    canActivate: [UserGuard, MerchantGuard, RoleAdminGuard, HasActiveSubscriptionGuard],
  },
  {
    path: 'dashboard',
    children: dashboardRoutes,
    canActivate: [UserGuard, MerchantGuard],
    data: { state: 'dashboard' },
  },
  {
    path: ':slug/editor',
    children: clientEditorRoutes,
    canActivate: [UserGuard, MerchantGuard, RoleAdminGuard],
    data: { state: 'client' },
  },
  {
    path: ':slug/dashboard',
    children: dashboardRoutes,
    canActivate: [UserGuard, MerchantGuard],
    data: { state: 'dashboard' },
  },
  {
    path: 'setup',
    children: onboardRoutes,
    canActivate: [UserGuard],
    data: { state: 'onboard' },
  },
  {
    path: 'moloni/auth',
    canActivate: [UserGuard, MerchantGuard],
    pathMatch: 'full',
    component: MoloniOauthComponent,
  },
  {
    path: 'qr/:uuid',
    children: clientRoutes,
    canActivate: [],
  },
  ...languageRoutes,
  {
    path: ':slug',
    children: clientRoutes,
    canActivate: [SetLanguageGuard],
  },
  {
    path: ':slug/**',
    canActivate: [SetLanguageGuard],
    children: clientRoutes,
  },
  { path: '**', redirectTo: '' },
];
